<div class="diseases-container">
  <div class="diseases-intro">
    <p class="intro-text">
      <mat-icon color="primary">gavel</mat-icon>
      Sélectionnez les dépistages pour lesquels un appel est nécessaire.
      Le lecteur en appel ne pourra modifier que les résultats de ces dépistages.
    </p>
  </div>

  <div class="diseases-list">
    <div class="disease-item" *ngFor="let disease of diseases">
      <mat-checkbox
        [(ngModel)]="disease.selected"
        color="primary">
        <div class="disease-info">
          <span class="disease-name">{{ disease.name }}</span>
          <span class="disease-code">({{ disease.code }})</span>
        </div>
      </mat-checkbox>
    </div>
  </div>

  <div class="selection-summary" *ngIf="getSelectedCount() > 0">
    <mat-icon color="accent">info</mat-icon>
    <span>{{ getSelectedCount() }} dépistage{{ getSelectedCount() > 1 ? 's' : '' }} sélectionné{{ getSelectedCount() > 1 ? 's' : '' }} pour l'appel</span>
  </div>
</div>
